import { Outlet, useLocation } from "react-router-dom";
import { ActiveBrandProvider } from "../../contexts/ActiveBrandContext";
import { Sidebar } from "./Sidebar";
import { AppBottomNav } from "./AppBottomNav";
import { MobileBrandBar } from "./MobileBrandBar";
import { ToastViewport } from "../../lib/toast";
import { isV2WorkspaceRoute, isViewportClampedWorkspaceRoute } from "../../lib/v2-routes";

export function Layout() {
  return (
    <ActiveBrandProvider>
      <LayoutShell />
    </ActiveBrandProvider>
  );
}

function LayoutShell() {
  const location = useLocation();
  const compactChrome = isV2WorkspaceRoute(location.pathname);
  const viewportClampedRoute = isViewportClampedWorkspaceRoute(location.pathname);
  // Sidebar is a 60px rail on every desktop route. Keeping this shared offset
  // prevents legacy routes from reserving the retired expanded navigation pane.
  const desktopOffset = "md:ml-[60px]";
  const mainSpacing = compactChrome
    ? viewportClampedRoute
      ? "px-0 pb-0 md:px-0 md:pb-0"
      : "px-0 pb-[var(--app-bottom-nav-safe-height)] md:px-0 md:pb-0"
    : "px-4 pb-[var(--app-bottom-nav-safe-height)] pt-0 md:px-8 md:pb-10 md:pt-5 lg:px-10";

  return (
    <div className="min-h-screen bg-slate-100 text-slate-900">
      <Sidebar />
      <main
        className={`mx-auto min-h-screen ${mainSpacing} ${desktopOffset}`}
      >
        <MobileBrandBar />
        <Outlet />
      </main>
      <ToastViewport />
      <AppBottomNav />
    </div>
  );
}
